/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { patterns } from "@utils/help";
import { colors } from "@utils/ui_palette";
import { IModule } from "@pages/AssessmentDetail";
import DefaultModal from "../modal/DefaultModal";

interface IPatterns {
  type: string;
  item: IModule;
  anwserCallback: (item: IModule, type: string) => Promise<void>;
}

function Patterns({ type, item, anwserCallback }: IPatterns) {
  const [modal, setModal] = useState<boolean>(false);

  const handleModal = useCallback(
    (state: boolean) => {
      setModal(state);
    },
    [setModal]
  );

  const getQuestionState = useCallback(() => {
    if (!item.answer_submit) {
      item.answer_submit = "";
    }

    const userAnwser = item.answer_submit.toString().toLocaleLowerCase();
    const anwser = item.anwser.toString().toLocaleLowerCase();

    if (type === "Create_pattern") {
      if (item.answer_submit === "") {
        return false;
      }
      const anwser = item.answer_submit ? item.answer_submit.split(",") : "";
      const anwser1 = anwser.slice(0, 2).toString();

      const anwser2 = anwser.slice(2, -2).toString();
      const anwser3 = anwser.slice(4).toString();

      if (anwser1 === anwser2 && anwser1 === anwser3) {
        return true;
      }

      const anwser4 = anwser.slice(0, 3).toString();
      const anwser5 = anwser.slice(3).toString();

      if (anwser4 === anwser5) {
        return true;
      }
    }
    return userAnwser === anwser;
  }, [item]);

  const getImage = useCallback((color: string, shape: string): string => {
    const colors = patterns.color.find((data) => data.code === color);
    const shapes = patterns.shape.find((data) => data.code === shape);

    if (!colors || !shapes) {
      return "";
    }

    return `https://podoi-uploads.s3.ap-northeast-2.amazonaws.com/patterns/${colors.type}/${shapes.type}.png`;
  }, []);

  return (
    <>
      <Container
        key={`report-${type}-${item.id}`}
        active={getQuestionState()}
        onClick={() => handleModal(true)}
      >
        {type === "Patterns" && (
          <QuestionPatterns>
            {item.anwser.split(",").map((pattern, index) => (
              <QuestionImage
                key={`Patterts-${pattern}-${index}`}
                src={getImage(pattern[0], pattern[1])}
              />
            ))}
          </QuestionPatterns>
        )}

        <UserAnwserPattern>
          {item.answer_submit &&
            item.answer_submit
              .split(",")
              .map((pattern, index) => (
                <QuestionImage
                  key={`Patterts-anwser-${pattern}-${index}`}
                  src={getImage(pattern[0], pattern[1])}
                />
              ))}
        </UserAnwserPattern>
      </Container>

      {modal && (
        <DefaultModal
          item={item}
          type={type}
          handleModal={handleModal}
          callback={anwserCallback}
        />
      )}
    </>
  );
}

const Container = styled.div<{ active: boolean }>`
  flex-basis: 100%;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: ${(props) =>
    `${props.active ? "1px" : "2px"} solid ${
      props.active ? colors.Gray30 : colors.Error20
    };`};
  box-shadow: 5px 5px 10px ${colors.Gray30};
  margin-right: 20px;
  cursor: pointer;
`;

const QuestionPatterns = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 1px solid ${colors.Gray30};
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto;
  padding: 20px;
  margin-bottom: 40px;
`;

const QuestionImage = styled("img")`
  height: 100px;
`;

const UserAnwserPattern = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 1px solid ${colors.Gray30};
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto;
  padding: 20px;
`;

export default Patterns;
